import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Partner } from 'src/app/shared/models/partner';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Observable, zip } from 'rxjs';

@Component({
  selector: 'app-export-pro-modal',
  templateUrl: './export-pro-modal.component.html',
  styleUrls: ['./export-pro-modal.component.scss']
})
export class ExportProModalComponent implements OnInit {

  partner: Partner;
  pro: any;
  // pros: any;
  partnerId: any;
  includedFilterCategoriesNames = [];
  excludedFilterCategoriesNames = [];
  selectedDataSet: any;

  exporting = false;

  //test data
  pros = [
    // {
    //   pdfSelected: false,
    //   csvSelected: false,
    //   xlsxSelected: false,
    //   type: 'Source Audio',
    //   year: 2023,
    //   quarter: 'Q1'
    // },
    {
      pdfSelected: false,
      csvSelected: false,
      xlsxSelected: false,
      type: 'ASCAP',
      year: 2025,
      quarter: 'Q1'
    },
    // {
    //   pdfSelected: false,
    //   csvSelected: false,
    //   type: 'BMI',
    //   year: 2023,
    //   quarter: 'Q1'
    // }
  ]


  constructor(private userService: UserService, private importService: ImportService, 
    private partnerService: PartnerService, private snackbarService: 
    SnackBarService, public dialogRef: MatDialogRef<ExportProModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      if (data.pros) {
        this.pros = data.pros;
      }
      if (data.partnerId) {
        this.partnerId = data.partnerId;
      }
    }

  ngOnInit() {

    //track selected partner
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;
    })

    //first, determine & track the selected data set
    this.partnerService.currentUserSelectedDataSet$.subscribe((x) => {
      this.selectedDataSet = x;

      if (this.selectedDataSet) {
        //we have a data set, apply filtering to the table
        //NOTE: BACKEND FILTERING IS APPLIED TO THE RETURNED DATA - THIS WILL JUST BE USED FOR 
        //UI RENDERING PURPOSES

        //reset columns back to all, we will filter from here
        // this.columns = this.partnerService.masterColumns.slice()

        //sort alphabetically
        this.selectedDataSet.properties.sort((a, b) => {
          return a.propertyName.localeCompare(b.propertyName);
        });

        this.selectedDataSet.properties.forEach(prop => {
          //check if isSelected = false, if so, remove
          //this property from the column list
          if (prop.isSelected == true) {
            this.includedFilterCategoriesNames.push(prop.propertyName);
          } else if (prop.isSelected != true || prop.isRestricted) {
            this.excludedFilterCategoriesNames.push(prop.propertyName);
          }

        })

        console.log(this.includedFilterCategoriesNames);

      }
      else {
        //there is not saved settings for this pro type and user
        //all columns will be displayed by default
        //THIS MAY REQUIRE A DIFFERENT DEFAULT FOR SECURITY REASONS
      }

    })
  }

  exportPros() {

    this.exporting = true;

    let calls: Observable<any>[] = [];

    this.pros.forEach(pro => {
      // if(pro.pdfSelected){

      //   //test code - hard coding partner pro ids and export type for proof of concept
      //   this.importService.exportPartnerPros(prosList, 'pdf', `${pro.type}_${pro.year}_${pro.quarter}`);

      // }

      if(pro.csvSelected){
        if (this.partnerService.exportedProIDs) {
          calls.push(this.importService.exportPartnerPros(this.partnerService.exportedProIDs, 'csv', `${this.partner ? this.partner.name + '_' : ''}${pro.type}_${pro.year}_${pro.quarter}`, this.partnerId, this.includedFilterCategoriesNames, this.excludedFilterCategoriesNames));
          // this.importService.exportPartnerPros(this.partnerService.exportedProIDs, this.partnerId, 'csv', `${pro.type}_${pro.year}_${pro.quarter}`);
        }
      }
      if(pro.pdfSelected){
        if (this.partnerService.exportedProIDs) {
          calls.push(this.importService.exportPartnerPros(this.partnerService.exportedProIDs, 'pdf', `${this.partner ? this.partner.name + '_' : ''}${pro.type}_${pro.year}_${pro.quarter}`, this.partnerId, this.includedFilterCategoriesNames, this.excludedFilterCategoriesNames));
          // this.importService.exportPartnerPros(this.partnerService.exportedProIDs, this.partnerId, 'csv', `${pro.type}_${pro.year}_${pro.quarter}`);
        }
      }
      if(pro.xlsxSelected){
        if (this.partnerService.exportedProIDs) {
          calls.push(this.importService.exportPartnerPros(this.partnerService.exportedProIDs, 'xlsx', `${this.partner ? this.partner.name + '_' : ''}${pro.type}_${pro.year}_${pro.quarter}`, this.partnerId, this.includedFilterCategoriesNames, this.excludedFilterCategoriesNames));
          // this.importService.exportPartnerPros(this.partnerService.exportedProIDs, this.partnerId, 'csv', `${pro.type}_${pro.year}_${pro.quarter}`);
        }
      }

      // if(pro.xlsxSelected){

      //   //test code - hard coding partner pro ids and export type for proof of concept
      //   this.importService.exportPartnerPros([1117, 1118, 1119, 1120, 1121], 'xlsx', `${pro.type}_${pro.year}_${pro.quarter}`);

      // }
    })

    zip(...calls).subscribe(x => this.exporting = false, x => this.exporting = false);
    
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
